// extracted by mini-css-extract-plugin
export var smallSpinner = "_qz-0";